import React, { useState } from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem2xs10,
    GridItem2xs10NotIsXsDownScreen,
    GridItem3xs10,
    GridItem4xs10,
    GridItem4xs10NotIsXsDownScreen,
    GridItem5,
    GridItem6,
    GridItem7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoPatrimonioImobilizadoList from '../../../business-rules/List/tipoPatrimonioImobilizadoList'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoPatrimonioImobilizado,
    rowPertentePagePatrimonioImobilizado,
    setPageInclusaoPatrimonioImobilizado,
    Familiar,
    TipoPatrimonioImobilizado,
    IconButtonClearEntradaDadosPatrimonioImobilizado,
    Valor,
    UfItcmd,
    PercPatrimonioImobilizadoCliente,
    PercPatrimonioImobilizadoConjuge,
    DescricaoOutros,
} from '../garantias-form/GarantiasCompPatrimonioImobilizado'

import {
    incrementaContPatrimonioImobilizado,
    processaRegistrosDefaultIniciaisPatrimonioImobilizado,
    processaValoresDefaultIniciaisPatrimonioImobilizado,
    calculaTotaisPatrimonioImobilizado,
} from '../garantias-form/GarantiasServicePatrimonioImobilizado'

import {
    processaFormRegistrosDefaultIniciaisSortAscFamiliar
} from './FormService'

import GarantiasFormPatrimonioImobilizadoItem from '../garantias-form/GarantiasFormPatrimonioImobilizadoItem'


const FormFormPatrimonioImobilizado = ({ values, handleChange, setFieldValue, title }) => {
    
    const [expandiu, setExpandiu] = useState(false)

    calculaTotaisPatrimonioImobilizado(values)
    
    useSingleton(async () => {

        processaFormRegistrosDefaultIniciaisSortAscFamiliar(values, values.totalPatrimonioImobilizado, processaRegistrosDefaultIniciaisPatrimonioImobilizado,
            values.patrimonioImobilizado)

        values.pagePatrimonioImobilizado = obtemPage(values.pagePatrimonioImobilizadoList, HARDCODE.idFamiliarPage)
    })

    values.processarIncluiReceitaMensalInssPensaoAluguelPatrimonioImobilizadoAluguel = true

    salvaPage(values.pagePatrimonioImobilizado, values.pagePatrimonioImobilizadoList, HARDCODE.idFamiliarPage)

    values.patrimonioImobilizadoPagination = values.patrimonioImobilizado

    const isXsDownScreen = IsXsDownScreen()



    return (
        <FieldArray name="patrimonioImobilizado">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.patrimonioImobilizado?.map((item, ind) => {

                            if (rowPertentePagePatrimonioImobilizado(values, ind)) {

                                processaValoresDefaultIniciaisPatrimonioImobilizado(item, values)
                                
                                let tipoPatrimonioImobilizadoSelecionado = pesquisaList(tipoPatrimonioImobilizadoList, 
                                    item.tipoPatrimonioImobilizado)

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem3xs10>
                                                <GridContainer>
                                                    <GridItem6>
                                                        <Familiar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem6>
                                                    
                                                    <GridItem6>
                                                        <TipoPatrimonioImobilizado
                                                            TextFieldNumberSelectTipoPatrimonioImobilizado={
                                                                TextFieldNumberSelect
                                                            }
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem3xs10>

                                            {item.tipoPatrimonioImobilizado
                                                ?
                                                    <GridItem4xs10>
                                                        <GridContainer>
                                                            <GridItem5>
                                                                <Valor
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem5>

                                                            {tipoPatrimonioImobilizadoSelecionado.informaUfItcmd === "S" &&
                                                            (!item.naoInventariar || item.ufItcmd) && (
                                                                <GridItem7>
                                                                    <UfItcmd
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange}
                                                                        expandiu={expandiu}
                                                                    />
                                                                </GridItem7>
                                                            )}
                                                        </GridContainer>
                                                    </GridItem4xs10>
                                                :
                                                    <GridItem4xs10NotIsXsDownScreen/>
                                            }

                                            {item.tipoPatrimonioImobilizado && item.familiar === HARDCODE.idFamiliarCasal
                                                ?
                                                    <GridItem2xs10>
                                                        <GridContainer>
                                                            <GridItem6>
                                                                <PercPatrimonioImobilizadoCliente
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem6>
                                                            <GridItem6>
                                                                <PercPatrimonioImobilizadoConjuge
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                />
                                                            </GridItem6>
                                                        </GridContainer>
                                                    </GridItem2xs10>
                                                :
                                                    <GridItem2xs10NotIsXsDownScreen />
                                            }

                                            <GridItem2xs10>
                                                <DescricaoOutros
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange} 
                                                    expandiu={expandiu}
                                                />
                                            </GridItem2xs10>

                                            <GridItem1xs2>
                                                <GridContainer>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <CustomizedDialogsPopup
                                                            maxWidth="sm"
                                                            popupTitle={title}
                                                            tooltipTitle={LABEL.expandir}
                                                            PopupButton={IconButtonMaisInformacoes}
                                                            popupButtonDestaque={false}
                                                            DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                                                            popupComponent={
                                                                <GarantiasFormPatrimonioImobilizadoItem
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    setFieldValue={setFieldValue}
                                                                    arrayHelpers={arrayHelpers}
                                                                    tipoPatrimonioImobilizadoSelecionado={
                                                                        tipoPatrimonioImobilizadoSelecionado
                                                                    }
                                                                    item={item}
                                                                    ind={ind}
                                                                    simplificado={true}
                                                                />
                                                            }
                                                            open={setExpandiu}
                                                            afterClose={setExpandiu}
                                                        />
                                                    </GridItem6>
                                                    <GridItem6
                                                        className="mt-2"
                                                    >
                                                        <IconButtonClearEntradaDadosPatrimonioImobilizado
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                            item={item}
                                                            ind={ind}
                                                            arrayHelpers={arrayHelpers}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem1xs2>
                                        </GridContainer>
                                        
                                        {isXsDownScreen && values.patrimonioImobilizadoPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )

                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoPatrimonioImobilizado
                        values={values}
                        setFieldValue={setFieldValue}
                    />

                    <GridContainerGridItemButtonIncluirLinha>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirPatrimonioImobilizado} 
                            align='right'
                            disabled={familiaresList(values).length === 0 ? true : false}
                            onClick={() => 
                                {
                                    incrementaContPatrimonioImobilizado(values)
                                    arrayHelpers.push({
                                        id: values.contPatrimonioImobilizado,
                                        familiar: HARDCODE.idFamiliarCliente,
                                    })
                                    setPageInclusaoPatrimonioImobilizado(values, setFieldValue)
                                }
                            }
                        />
                    </GridContainerGridItemButtonIncluirLinha>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormPatrimonioImobilizado